import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/stat_car_stranded/list',
    method: 'post',
    data,
  })
}
